import React from 'react';
import './HeroSection.scss';
import heroNew from '../../../assets/images/home-page/heroNew.png';
import beaconLogo from '../../../assets/images/Horizontal.svg';
import { Labels } from './model';

export const Hero: React.FC = () => {
	return (
		<section className='hero-section' aria-labelledby='section-hero'>
			<div className='media-container'>
				<img className='welcome-image' src={heroNew} alt='Beacon Discovery By New Hope Network' />
			</div>

			<div className='background-overlay' aria-hidden='true' />

			<div className='content'>
				<div className='beacon-logo'>
					{' '}
					<img src={beaconLogo} className='brand-logo' alt='Beacon' />
				</div>
				<h1 id='section-hero' className='logo-description'>
					{Labels.logo_description}
				</h1>
				<h2 className='first-description'>{Labels.first_description}</h2>
				<p className='second-description'>{Labels.second_description}</p>
			</div>
		</section>
	);
};

export default Hero;
